import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ITimesheet } from "../../models/Timesheet";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { BillingCycle, IPurchaseOrder } from "../../models/PurchaseOrder";
import { ILogin } from "../../models/Login";
import { Card } from "primereact/card";
import { JVCheckbox } from "../../shared/JVCheckbox";

interface IProps {
    singleData: ITimesheet,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    po?: IPurchaseOrder,
    recent: ITimesheet,
}

const schema = yup.object({
    fromDate: yup.date().required("From Date is required").typeError("From Date is required"),
    toDate: yup.date().required("To Date is required").typeError("To Date is required"),
    workHours: yup.string().max(90).required("Work Hours is required"),
    overlapWorkHours: yup.number().max(68).nullable(),
    // timeSheet_Path: yup.string().required("TimesSheet is required"),
    isNotWorking: yup.boolean().nullable(),
    comments: yup.string().nullable(),
});

export const AddConsultantTimeSheet = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [timeSheetFile, setTimeSheetFile] = useState<File | null | any>(null);
    const [disableAllField, setDisableAllField] = useState(false);
    const [workHoursHeader, setWorkHoursHeader] = useState<string>("Work Hours");
    const [overlapHoursHeader, setOverlapHoursHeader] = useState<string>("Overlaping Hours");
    const [showOverlap, setShowOverlap] = useState<boolean>(false);
    const [openRules, setOpenRules] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<ITimesheet>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const fileUploade = (event: FileUploadHandlerParam) => {
        if (event.files[0].size >= 1024 * 1024 * 5) {
            props.toast.current.show({ severity: 'error', content: "Document should be less than 5 MB." });
            event.options.clear();
        } else {
            setTimeSheetFile(event.files[0]);
            props.toast.current.show({ severity: 'success', content: 'File Selected' });
            event.options.clear();
        }
    }

    // const uploadeFile = async (file: File) => {
    //     setLoading(true);
    //     let formData = new FormData();
    //     formData.append("file", file);

    //     const params = {
    //         method: "POST",
    //         headers: {
    //             'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
    //         },
    //         body: formData
    //     };
    //     const response = await fetch(`${baseUrl}Ticket/file`, params);
    //     if (response) {
    //         const data = await response.text();
    //         setValue("timeSheet_Path", data);
    //         props.toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
    //     }
    //     setLoading(false);
    // }

    const onSubmit = (data: ITimesheet) => {
        // data.consultant_ID = props.singleData.consultant_ID;
        // data.pO_ID = props.singleData.pO_ID;
        const toDate = new Date(data.toDate || "");
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (toDate > today) {
            props.toast.current.show({ severity: 'error', content: `Week not ended yet` });
        } else if (timeSheetFile === null && data.isNotWorking !== true && (data.timeSheet_Path === undefined || (data.timeSheet_Path === null && (`${data.timeSheet_Path}` || "").trim() === ""))) {
            props.toast.current.show({ severity: 'error', content: `Please Select A File` });
        } else {
            if ((Number(data?.workHours || "0") + Number(data?.overlapWorkHours || "0")) >= 91) {
                props.toast.current.show({ severity: 'error', content: `Working Hours can not be greater than 90` });
            } else saveToDB(data);
        }
    }

    const saveToDB = async (data: ITimesheet) => {
        if (!Number(data.workHours) && data.isNotWorking !== true) {
            props.toast.current.show({ severity: 'error', detail: "Working Hours Must Be In Numbers", life: 3000 });
        } else {
            setLoading(true);
            let body: any = data;
            body.consultant_ID = props?.po?.consultant_ID;
            body.workHours = Number(data.workHours);
            const method = props.singleData.timesheet_ID ? "PUT" : "POST";
            const message = props.singleData.timesheet_ID ? "Updated Successfully" : "Added Successfully";

            let extraQuery = "";
            if (loginObj.user_Type === 2) {
                extraQuery = `consultantUser=${loginObj.consultant_ID}&userType=${loginObj.user_Type}`;
            }

            if (loginObj.user_Type === 3) {
                extraQuery = `subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
            }

            const formData = new FormData();
            formData.append('file', timeSheetFile);
            formData.append('timesheet', JSON.stringify(body));
            //formData.append('userType', `${loginObj.user_Type}`);
            //formData.append('userID', `${loginObj.user_Type === 2 ? loginObj.consultant_ID : loginObj.sub_Vendor_ID}`);
            const params = {
                method: method,
                headers: {
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                },
                body: formData
            };
            const response = await fetch(`${baseUrl}ResourceTimesheet${data.isNotWorking === true ? "/notWorkingTimesheet" : ""}?${extraQuery}`, params);

            //const response = await Fetch("Timesheet", method, data, null, props.toast);
            if (response) {
                setDisableAllField(false);
                setTimeSheetFile(null);
                props.hideDialog();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
            }
            setLoading(false);
        }
    }

    const onHide = () => {
        setShowOverlap(false);
        setTimeSheetFile(null);
        setDisableAllField(false);
        props.hideDialog();
        reset();
    };

    const nextBtn = () => {
        let frmDate = control._formValues.fromDate;
        let tDate = control._formValues.toDate;
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "fromDate") {
                if (value.fromDate != null) {
                    const dayOfWeek = value.fromDate.getDay();
                    if (dayOfWeek === 0) {
                        setValue('toDate', value.fromDate);
                        setWorkHoursHeader("Work Hours");
                        setOverlapHoursHeader("Overlaping Hours");
                        setValue('overlapWorkHours', 0);
                        setShowOverlap(false);
                    } else {
                        const weekStartDay = props?.po?.timesheet_Week_Start_Day || 0;
                        let numberOfDaysToAdd = (weekStartDay - Number(new Date(value.fromDate)?.getDay()) + 7) % 7;
                        setValue('toDate', new Date(new Date(value.fromDate).setDate(new Date(value.fromDate).getDate() + numberOfDaysToAdd)));

                        const toDateIs: Date = new Date(new Date(value.fromDate).setDate(new Date(value.fromDate).getDate() + numberOfDaysToAdd));

                        if (new Date(value.fromDate || "").getMonth() + 1 !== new Date(toDateIs || "").getMonth() + 1) {
                            setShowOverlap(prev => prev = true);
                            const lastDateOfFrom = new Date(new Date(value.fromDate || "").getFullYear(), new Date(value.fromDate || "").getMonth() + 1, 0);
                            const firstDateOfTo = new Date(new Date(toDateIs || "").getFullYear(), new Date(toDateIs || "").getMonth(), 1);
                            setWorkHoursHeader(prev => prev = `Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1}-${new Date(value.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                            setOverlapHoursHeader(prev => prev = `Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDateIs || "").getDate()}-${new Date(toDateIs || "").getMonth() + 1}-${new Date(toDateIs || "").getFullYear()})`);
                        } else if (new Date(value.fromDate || "").getMonth() + 1 === new Date(toDateIs || "").getMonth() + 1) {
                            setWorkHoursHeader(prev => prev = "Work Hours");
                            setOverlapHoursHeader(prev => prev = "Overlaping Hours");
                            setValue('overlapWorkHours', 0);
                            setShowOverlap(prev => prev = false);
                        }

                        if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(value.fromDate || "").getDate() < 16 && new Date(toDateIs || "").getDate() >= 16) {
                            setShowOverlap(prev => prev = true);
                            const lastDateOfFrom = new Date(new Date(value.fromDate || "").getFullYear(), new Date(value.fromDate || "").getMonth(), 15);
                            const firstDateOfTo = new Date(new Date(toDateIs || "").getFullYear(), new Date(toDateIs || "").getMonth(), 16);
                            setWorkHoursHeader(prev => prev = `Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1}-${new Date(value.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                            setOverlapHoursHeader(prev => prev = `Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDateIs || "").getDate()}-${new Date(toDateIs || "").getMonth() + 1}-${new Date(toDateIs || "").getFullYear()})`);
                        }
                    }
                }
            }
            if (name === "isNotWorking") {
                if (value.isNotWorking === true) {
                    setValue("workHours", "0");
                    setValue("overlapWorkHours", 0);
                    setDisableAllField(prev => prev = true);
                } else setDisableAllField(prev => prev = false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, workHoursHeader, overlapHoursHeader, showOverlap, props.po]);

    useEffect(() => {
        if (props.open) {
            if (props.singleData?.timesheet_ID && props.singleData?.isNotWorking === true) {
                setDisableAllField(true);
            };
            const weekStartDay = props?.po?.timesheet_Week_Start_Day || 0;
            if (props.recent === undefined || props.recent?.toDate === null) {
                props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
                const currentDate = new Date(props?.po?.project_Start_Date || "");
                // let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay()));
                let numberOfDaysToAdd = (weekStartDay - Number(currentDate?.getDay()) + 7) % 7;
                const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
                props.singleData.toDate = toDate;
                reset(props.singleData);
            } else if (props.recent?.toDate && props.recent?.toDate !== null) {
                const date = new Date(props.recent?.toDate || "");

                // Get the current day of the week (0 for Sunday, 1 for Monday, etc.)
                const currentDay = date.getDay();

                // Calculate the number of days to add to get to the next Monday
                //const daysToAdd = (currentDay === 0) ? 1 : (8 - currentDay);
                let daysToAdd = ((weekStartDay + 1) - currentDay + 7) % 7;

                // Add the days to the current date
                date.setDate(date.getDate() + daysToAdd);

                // If you want the NEXT week start (not today if same day)
                if (daysToAdd === 0) { daysToAdd = 7; }

                // Return the new date in YYYY-MM-DD format
                // return date.toISOString().split('T')[0];

                const fromDate = new Date(date.toISOString());
                props.singleData.fromDate = fromDate;
                let numberOfDaysToAdd = (weekStartDay - Number(date?.getDay()) + 7) % 7;
                //const toDate = new Date(new Date(props.recent?.toDate || "").setDate(new Date(props.recent?.toDate || "").getDate() + numberOfDaysToAdd));
                const toDate = new Date(date.setDate(date.getDate() + numberOfDaysToAdd));
                props.singleData.toDate = toDate;
                reset(props.singleData);
            } else {
                reset(props.singleData);
            }

            if (props.singleData?.timesheet_ID && props.singleData?.isNotWorking === true) {
                setDisableAllField(prev => prev = true);
            }

            if (new Date(props.singleData?.fromDate || "").getMonth() + 1 !== new Date(props.singleData?.toDate || "").getMonth() + 1) {
                setShowOverlap(true);
                const lastDateOfFrom = new Date(new Date(props.singleData?.fromDate || "").getFullYear(), new Date(props.singleData?.fromDate || "").getMonth() + 1, 0);
                const firstDateOfTo = new Date(new Date(props.singleData?.toDate || "").getFullYear(), new Date(props.singleData?.toDate || "").getMonth(), 1);
                setWorkHoursHeader(`Work Hours : (${new Date(props.singleData?.fromDate || "").getDate()}-${new Date(props.singleData?.fromDate || "").getMonth() + 1}-${new Date(props.singleData?.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(props.singleData?.toDate || "").getDate()}-${new Date(props.singleData?.toDate || "").getMonth() + 1}-${new Date(props.singleData?.toDate || "").getFullYear()})`);
            }

            if ((props.po?.sub_Vendor_Billing_Cycle === BillingCycle.SemiMonthly || props.po?.prime_Vendor_Billing_Cycle === BillingCycle.SemiMonthly) && new Date(props.singleData?.fromDate || "").getDate() < 16 && new Date(props.singleData?.toDate || "").getDate() >= 16) {
                setShowOverlap(true);
                const lastDateOfFrom = new Date(new Date(props.singleData?.fromDate || "").getFullYear(), new Date(props.singleData?.fromDate || "").getMonth(), 15);
                const firstDateOfTo = new Date(new Date(props.singleData?.toDate || "").getFullYear(), new Date(props.singleData?.toDate || "").getMonth(), 16);
                setWorkHoursHeader(`Work Hours : (${new Date(props.singleData?.fromDate || "").getDate()}-${new Date(props.singleData?.fromDate || "").getMonth() + 1}-${new Date(props.singleData?.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(props.singleData?.toDate || "").getDate()}-${new Date(props.singleData?.toDate || "").getMonth() + 1}-${new Date(props.singleData?.toDate || "").getFullYear()})`);
            }
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Update Consultant TimeSheet" modal className="p-fluid" onHide={onHide}>
            <div className="w-full flex flex-row-reverse"><Button icon="pi pi-info-circle" tooltip="Help" onClick={() => setOpenRules(true)} /></div>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                <JVDate required column={3} maxDate={new Date()} label="From Date" control={control} name="fromDate" error={errors.fromDate?.message} />
                <JVDate required column={3} maxDate={new Date()} disabled label="To Date" control={control} name="toDate" error={errors.toDate?.message} />
                <JVInput required column={3} label={workHoursHeader} disabled={disableAllField} control={control} name="workHours" error={errors.workHours?.message} />
                {showOverlap && <JVInput required column={3} label={overlapHoursHeader} disabled={disableAllField && showOverlap} control={control} name="overlapWorkHours" error={errors.overlapWorkHours?.message} />}
                <div className="field col-12 md:col-4">
                    <label htmlFor="file">TimeSheet<span style={{ color: 'red' }}>*</span></label>
                    <FileUpload chooseLabel="Choose File" disabled={disableAllField} mode="basic" name="file" accept="*" maxFileSize={10000000} customUpload auto uploadHandler={fileUploade} />
                    {errors.timeSheet_Path?.message && <small className="p-error" >{errors.timeSheet_Path?.message}</small>}
                </div>
                <div className="field col-12 md:col-1 pt-5">
                    <JVCheckbox column={1} label="Not Worked" control={control} name="isNotWorking" />
                </div>
                <JVInput column={2} label="Comment" control={control} name="comments" error={errors.comments?.message} />

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
            <Dialog visible={openRules} style={{ width: '80vw' }} header="Help — Add/Update Consultant Timesheet" modal className="p-fluid" onHide={() => setOpenRules(false)}>
                <div className="mission-header">
                    <hr />
                    <h2>🗓️ 1. From Date & To Date</h2>
                    <p style={{ fontWeight: "bold" }}>- These fields define the start and end dates of the week for which you are submitting your timesheet.</p>
                    <p style={{ fontWeight: "bold" }}>- Example:</p>
                    <p className="pl-5">    - From Date: 30-06-2025</p>
                    <p className="pl-5">    - To Date: 06-07-2025</p>
                    <p>⚠️ Make sure the selected dates represent a valid weekly range.</p>
                    <hr />
                    <h2>⏰ 2. Work Hours</h2>
                    <p style={{ fontWeight: "bold" }}>- This field is for entering total work hours between the From Date and To Date. (max 48 Hrs)</p>
                    <p style={{ fontWeight: "bold" }}>- Example: 40 hours or 8 hours per day.</p>
                    <p style={{ fontWeight: "bold" }}>- If the selected dates span two different months:</p>
                    <p className="pl-5">- The system automatically divides the week into two parts:</p>
                    <p className="pl-5">    - Work Hours → For the period within the From Date’s month</p>
                    <p className="pl-5">    - Overlap Hours → For the period that falls into the To Date’s month</p>
                    <p style={{ fontWeight: "bold" }}>- Example:</p>
                    <p className="pl-5">    - From Date: 30-06-2025</p>
                    <p className="pl-5">    - To Date: 06-07-2025</p>
                    <p className="pl-5">    - You’ll see two fields:</p>
                    <p className="pl-5"><p className="pl-5"> - Work Hours (30-06-2025 to 30-06-2025)</p></p>
                    <p className="pl-5"><p className="pl-5"> - Overlap Hours (01-07-2025 to 06-07-2025)</p></p>
                    <hr />
                    <h2>📎 3. Timesheet Upload</h2>
                    <p style={{ fontWeight: "bold" }}>- Use the “+ Choose File” button to upload your completed timesheet file (e.g., PDF, Excel, or image).</p>
                    <p style={{ fontWeight: "bold" }}>- Ensure the uploaded file corresponds to the selected date range.</p>
                    <hr />
                    <h2>🚫 4. Not Worked Checkbox</h2>
                    <p style={{ fontWeight: "bold" }}>- If you did not work during the selected period:</p>
                    <p className="pl-5">    - Check the “Not Worked” box.</p>
                    <p className="pl-5">    - All “Work Hours” and “Overlap Hours” input fields and the upload button will be disabled automatically.</p>
                    <p className="pl-5">    - No need to upload a timesheet file.</p>
                    <hr />
                    <h2>💬 5. Comment</h2>
                    <p style={{ fontWeight: "bold" }}>- Use this field to provide any additional information or clarification related to your timesheet.</p>
                    <p style={{ fontWeight: "bold" }}>- Example:</p>
                    <p className="pl-5">    - “Was on leave for 2 days due to illness.”</p>
                    <p className="pl-5">    - “Worked extra hours on Friday.”</p>
                    <hr />
                    <h2>💾 6. Save & Close</h2>
                    <p style={{ fontWeight: "bold" }}>- SAVE → Click this button to submit or update your timesheet details.</p>
                    <p style={{ fontWeight: "bold" }}>- CLOSE → Exit the form without saving changes.</p>
                    <hr />
                </div>
            </Dialog>
        </Dialog>
    );
}